import { useEffect, useState } from "react";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import TabsHeader from "../components/TabsHeader";
import { postConsultaCV } from "../helpers/uploadCV";
import { postConsulta } from "../helpers/contacto";
import toast from "react-hot-toast";
import pushDataLayerEvent from 'react-gtm-module';
import { PDFtype } from "../helpers/constants";
import useLocation from "../hooks/useLocation";
import { Helmet, HelmetProvider } from "react-helmet-async";

import imgIntro from "../assets/images/nodinamic/trabajar-con-nosotros.jpg";
import { usePuntoVentaFormValidator } from "../hooks/usePuntoVentaFormValidator";
import { useCargaCvFormValidator } from "../hooks/useCargaCvFormValidator";

const UploadCV = () => {
  const [formContactKey, setFormContactKey] = useState(0);
  const [formWorkWithUsKey, setFormWorkWithUsKey] = useState(0);
  const [activoCv, setActivoCv] = useState(false);
  const { getCountriesFunc, getProvincesFunc } = useLocation();
  const [provinces, setProvinces] = useState([]);
  const [countries, setCountries] = useState([]);
  const [formValue, setFormValue] = useState({
    origin: "7",
    subject: "7",
    company: "",
    name: "",
    email: "",
    dni_cuit: "",
    country: "",
    province: "",
    codCountry: "54",
    codArea: "",
    phone: "",
  });
  const [formCv, setFormCv] = useState({
    origin: "8",
    subject: "8",
    name: "",
    email: "",
    profession: "",
    education: "",
    site: "",
    codCountry: "54",
    codArea: "",
    phone: "",
    filename: "",
  });

  useEffect(() => {
    const getFormInfo = async () => {
      try {
        const [countriesInfo, provincesInfo] = await Promise.all([
          getCountriesFunc(),
          getProvincesFunc()
        ])
        setCountries(countriesInfo);
        setProvinces(provincesInfo);
      } catch (error) {
        toast.error('Error al obtener ')
      }
    }
    getFormInfo();
  }, []);

  useEffect(() => {
    const inputToFocus = document.getElementById('nombre-apellido');
    if (inputToFocus) {
      inputToFocus.focus();
    }
  }, []);

  const { errors, validateForm, onBlurField } =
    usePuntoVentaFormValidator(formValue);

  const { errorsCv, validateFormCv, onBlurFieldCv } =
    useCargaCvFormValidator(formCv);

  function handleChange({ target }) {
    const field = target.name;
    const nextFormState = {
      ...formValue,
      [field]: target.value,
    };

    if (target) {
      setFormValue({
        ...formValue,
        [target.name]: target.value,
      });
      if (errors[field].dirty) {
        validateForm({
          form: nextFormState,
          errors,
          field,
        });
      }
    }
  }

  const handleCV = ({ target }) => {
    const field = target.name;

    const nextFormStateCv = {
      ...formCv,
      [field]: target.value,
    };

    if (target) {
      setFormCv({
        ...formCv,
        [target.name]: target.value,
      });
      if (errorsCv[field].dirty) {
        validateFormCv({
          form: nextFormStateCv,
          errors: errorsCv,
          field,
        });
      }
    }
  };
  const handleFileCv = ({ target }) => {
    const file = target.files[0];
    const field = target.name;
    const nextFormState = {
      ...formCv,
      [field]: target.value,
    };
    if (document.querySelector("#filename").value === "") {
      document.querySelector("#filename").value = "";
      return toast.error("El archivo debe tener un nombre");
    }
    if (target.files && target.files[0].type !== PDFtype) {
      return toast.error("El archivo debe ser un PDF"); 
    }
    if (target) {
      setFormCv({
        ...formCv,
        [target.name]: file,
      });
      if (errorsCv[field].dirty) {
        validateFormCv({
          form: nextFormState,
          errors: errorsCv,
          field,
        });
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const { isValid } = validateForm({
      form: formValue,
      errors,
      forceTouchErrors: true,
    });
    if (!isValid) return;

    postConsulta(formValue)
      .then((respuesta) => {
        toast.success("Formulario enviado!");
        setFormValue({
          origin: "7",
          subject: "7",
          province: "",
          company: "",
          name: "",
          email: "",
          dni_cuit: "",
          country: "",
          codCountry: "54",
          codArea: "",
          phone: "",
        });
        setFormContactKey(formContactKey + 1)
      })
      .catch((error) => {
        const hasErrors = Object.values(errorsCv).some(field => field.error);
        if (hasErrors) {
          toast.error("Complete los campos requeridos");
        }
      });

    pushDataLayerEvent({
      event: `formCV`,
      'formulario-id': `${e.target.id}`
    });
  };

  const handleSubmitCV = (e) => {
    e.preventDefault();
    const { isValid } = validateFormCv({
      form: formCv,
      errors: errorsCv,
      forceTouchErrors: true,
    });
    if (!isValid) return;

    postConsultaCV(formCv)
      .then((respuesta) => {
        toast.success("Formulario enviado!");
        setFormCv({
          origin: "8",
          subject: "8",
          name: "",
          email: "",
          profession: "",
          education: "",
          site: "",
          codCountry: "54",
          codArea: "",
          phone: "",
          filename: "",
        });

        pushDataLayerEvent({
          event: `formCV`,
          'formulario-id': `${e.target.id}`
        });
        setFormWorkWithUsKey(formWorkWithUsKey + 1)
      })
      .catch((error) => {
        const hasErrors = Object.values(errorsCv).some(field => field.error);
        if (hasErrors) {
          toast.error("Complete los campos requeridos");
        }
      });
  };

  useEffect(() => {
    setActivoCv(true);
  }, []);

  return (
    <>
      <HelmetProvider>
        <Helmet prioritizeSeoTags>
          <title>Trabajá en Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón</title>
          <meta name="title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta name="description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta itemProp="image" content="https://tensolite.com/images/redes.png" />
          <meta name="author" content="Sitenso"></meta>

          <meta property="og:type" content="website" />
          <meta property="og:url" content={`https://tensolite.com`} />
          <meta property="og:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="og:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="og:image" content="https://tensolite.com/images/redes.png" />

          <meta property="twitter:card" content="summary_large_image" />
          <meta property="twitter:url" content={`https://tensolite.com`} />
          <meta property="twitter:title" content="Tensolite | Fábrica de Premoldeados y Pretensados de Hormigón" />
          <meta property="twitter:description" content="Fábrica de premoldeados y pretensados de hormigón. Vigueta, bloque, adoquín, teja y productos especiales de hormigón. Obras públicas y civiles." />
          <meta property="twitter:image" content="https://tensolite.com/images/redes.png" />
        </Helmet>
      </HelmetProvider>
      <div
        id="cv-section"
        aria-labelledby="trabaja-con-nosotros"
        className="bg-fullpage"
      >
        <img src={imgIntro} alt="" className="imagen-fondo" />

        <div className="container">
          <header id="trabaja-con-nosotros">
            <h1>El poder de trabajar juntos</h1>
            <p>
              Trabajamos firmemente para que puedas brindar una excelente
              experiencia de compra a tus clientes
            </p>
          </header>
          <TabsHeader activoCv={activoCv} />
        </div>
      </div>
      <div className="container">
        <section aria-labelledby="soycorralon">
          <header>
            <h2 id="soycorralon" className="id-section-cargacv">
              Sumate a nuestros puntos de venta
            </h2>
            <p>
              Cargá tus datos y los de tu empresa así nos ponemos en contacto
              con vos.
            </p>
          </header>
          <form key={`contact-${formContactKey}-key`} id="contact_corralones" className="settings__form-styles" onSubmit={handleSubmit}>
            <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">
              <div className="mb-4 col-100">
                <input
                  id="nombre-empresa"
                  name="company"
                  type="text"
                  value={formValue.company}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Nombre de la empresa"
                  className={`${errors.company.error ? "red-advertise" : ""} `}
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.company.dirty && errors.company.error ? (
                  <p className="errors-msg">{errors.company.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="nombre-contacto"
                  name="name"
                  type="text"
                  value={formValue.name}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="Nombre del contacto"
                  className={`${errors.name.error ? "red-advertise" : ""} `}
                  maxLength={30}
                  minLength={2}
                  required
                />
                {errors.name.dirty && errors.name.error ? (
                  <p className="errors-msg">{errors.name.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="email"
                  name="email"
                  type="email"
                  value={formValue.email}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  className={`${errors.email.error ? "red-advertise" : ""} `}
                  maxLength={50}
                  minLength={2}
                  required
                  placeholder="Email"
                />
                {errors.email.dirty && errors.email.error ? (
                  <p className="errors-msg">{errors.email.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="cuit"
                  name="dni_cuit"
                  type="text"
                  value={formValue.dni_cuit}
                  onChange={handleChange}
                  onBlur={onBlurField}
                  placeholder="CUIT o DNI"
                  className={`${errors.dni_cuit.error ? "red-advertise" : ""} `}
                  maxLength={30}
                  minLength={2}
                  required
                />
                <p className="text-coment">Ingresar solamente números</p>
                {errors.dni_cuit.dirty && errors.dni_cuit.error ? (
                  <p className="errors-msg">{errors.dni_cuit.message}</p>
                ) : null}
              </div>
            </fieldset>
            <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
              <div className="mb-4 col-100">
                <select name="country" onChange={handleChange} value={formValue?.country}>
                  <option selected disabled value=''>
                    País
                  </option>
                  {countries?.country?.map((country) => (
                    <option
                      value={country?.country_name}
                      id={country?.country_short_name}
                    >
                      {country?.country_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="mb-4 col-100">
                {formValue?.country === "Argentina" ? (
                  <select name="province" onChange={handleChange}>
                    <option selected disabled>
                      Provincia
                    </option>
                    {provinces?.province?.map((province) => (
                      <option
                        value={province?.province_name}
                        id={province?.province_id}
                      >
                        {province?.province_name}
                      </option>
                    ))}
                  </select>
                ) : (
                  <input
                    id="nombre-provincia"
                    name="province"
                    type="text"
                    value={formValue.province}
                    onChange={handleChange}
                    onBlur={onBlurField}
                    placeholder="Provincia o estado"
                    maxLength={30}
                    minLength={2}
                  />
                )}
              </div>
              <div className="mb-4 col-100">
                <div className="row ml-1">
                  <div className="col-3">
                    <select name="codCountry" onChange={handleChange}>
                      {countries?.country?.map((country) => (
                        <option
                          value={country?.country_phone_code}
                          id={country?.country_phone_code}
                          selected={country?.country_phone_code === 54}
                        >
                          {`+ ${country?.country_phone_code} (${country?.country_short_name})`}
                        </option>
                      ))}
                    </select>
                    {errors.codCountry.dirty && errors.codCountry.error ? (
                      <p className="errors-msg">{errors.codCountry.message}</p>
                    ) : null}
                  </div>
                  <div className="col-4">
                    <input
                      id="cod-area"
                      name="codArea"
                      type="tel"
                      value={formValue.codArea}
                      onChange={handleChange}
                      onBlur={onBlurField}
                      className={`${errors.codArea.error ? "red-advertise" : ""
                        } `}
                      maxLength={10}
                      minLength={2}
                      placeholder="Cod. área (Ej: 381)"
                    />
                    {errors.codArea.dirty && errors.codArea.error ? (
                      <p className="errors-msg">{errors.codArea.message}</p>
                    ) : null}
                  </div>
                  <div className="col-5">
                    <input
                      id="telefono"
                      name="phone"
                      type="tel"
                      value={formValue.phone}
                      onChange={handleChange}
                      onBlur={onBlurField}
                      className={`${errors.phone.error ? "red-advertise" : ""
                        } `}
                      maxLength={20}
                      minLength={2}
                      placeholder="Teléfono"
                    />
                    {errors.phone.dirty && errors.phone.error ? (
                      <p className="errors-msg">{errors.phone.message}</p>
                    ) : null}
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-12">
              <button
                type="submit"
                className="settings_button-pleno bg-p-secondary button_mobile float-end d-flex justify-content-between"
              >
                Enviar <ArrowForwardIcon />
              </button>
            </div>
          </form>
        </section>
        <section aria-labelledby="trabajaconnosotros">
          <header>
            <h2 id="trabajaconnosotros" className="id-section-cargacv mt-2">
              Sumate a nuestro equipo
            </h2>
            <p>
              Nuestro equipo crece todos los días. Sumate a la familia del grupo
              Tensolite.
            </p>
          </header>
          <form key={`workWithUs-${formWorkWithUsKey}-key`} id="form_work_with_us" className="settings__form-styles" onSubmit={handleSubmitCV}>
            <fieldset className="col-12 col-sm-12 col-md-6 col-lg-6 settings__col-izquierda">
              <div className="mb-4 col-100">
                <input
                  id="nombre-apellido"
                  name="name"
                  type="text"
                  className={`${errorsCv.name.error ? "red-advertise" : ""} `}
                  value={formCv.name}
                  onChange={handleCV}
                  onBlur={onBlurFieldCv}
                  maxLength={30}
                  minLength={2}
                  placeholder="Nombre y apellido"
                />
                {errorsCv.name.dirty && errorsCv.name.error ? (
                  <p className="errors-msg">{errorsCv.name.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="email-cargacv"
                  name="email"
                  type="email"
                  className={`${errorsCv.email.error ? "red-advertise" : ""} `}
                  value={formCv.email}
                  onChange={handleCV}
                  onBlur={onBlurFieldCv}
                  placeholder="Email"
                  maxLength={40}
                  minLength={2}
                />
                {errorsCv.email.dirty && errorsCv.email.error ? (
                  <p className="errors-msg">{errorsCv.email.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-100">
                <input
                  id="profesión"
                  name="profession"
                  type="text"
                  className={`${errorsCv.profession.error ? "red-advertise" : ""
                    } `}
                  value={formCv.profession}
                  onChange={handleCV}
                  onBlur={onBlurFieldCv}
                  placeholder="Profesión"
                  maxLength={30}
                />
                {errorsCv.profession.dirty && errorsCv.profession.error ? (
                  <p className="errors-msg">{errorsCv.profession.message}</p>
                ) : null}
              </div>
            </fieldset>
            <fieldset className="col-sm-12 col-md-6 col-lg-6 settings__col-derecha">
              <div className="mb-4 col-100">
                <select
                  onChange={handleCV}
                  name="education"
                  value={formCv.education}
                  onBlur={onBlurFieldCv}
                  className={`${errorsCv.education.error ? "red-advertise" : ""
                    } `}
                >
                  <option>Estudios</option>
                  <option>Primario</option>
                  <option>Secundario</option>
                  <option>Secundario incompleto</option>
                  <option>Universitario</option>
                  <option>Otro</option>
                </select>
                {errorsCv.education.dirty && errorsCv.education.error ? (
                  <p className="errors-msg">{errorsCv.education.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-12">
                <select
                  name="site"
                  value={formCv.site}
                  onChange={handleCV}
                  onBlur={onBlurFieldCv}
                  className={`${errorsCv.site.error ? "red-advertise" : ""} `}
                >
                  <option>¿En que sede te gustaría trabajar?</option>
                  <option>Tucumán</option>
                  <option>Córdoba</option>
                </select>
                {errorsCv.site.dirty && errorsCv.site.error ? (
                  <p className="errors-msg">{errorsCv.site.message}</p>
                ) : null}
              </div>
              <div className="mb-4 col-12">
                <div className="row">
                  <div className="col-3">
                    <select name="codCountry" onChange={handleChange}>
                      {countries?.country?.map((country) => (
                        <option
                          value={country?.country_phone_code}
                          id={country?.country_phone_code}
                          selected={country?.country_phone_code === 54}
                        >
                          {`+ ${country?.country_phone_code} (${country?.country_short_name})`}
                        </option>
                      ))}
                    </select>
                    {errorsCv.codCountry.dirty && errorsCv.codCountry.error ? (
                      <p className="errors-msg">
                        {errorsCv.codCountry.message}
                      </p>
                    ) : null}
                  </div>
                  <div className="col-4">
                    <input
                      id="cod-area"
                      name="codArea"
                      type="tel"
                      className={`${errorsCv.codArea.error ? "red-advertise" : ""
                        } `}
                      value={formCv.codArea}
                      onChange={handleCV}
                      onBlur={onBlurFieldCv}
                      placeholder="Cod. área (Ej: 381)"
                      maxLength={10}
                      minLength={2}
                    />
                    {errorsCv.codArea.dirty && errorsCv.codArea.error ? (
                      <p className="errors-msg">{errorsCv.codArea.message}</p>
                    ) : null}
                  </div>
                  <div className="col-5">
                    {" "}
                    <input
                      id="telefono"
                      name="phone"
                      type="tel"
                      className={`${errorsCv.phone.error ? "red-advertise" : ""
                        } `}
                      value={formCv.phone}
                      onChange={handleCV}
                      onBlur={onBlurFieldCv}
                      placeholder="Teléfono"
                      maxLength={20}
                      minLength={2}
                    />
                    {errorsCv.phone.dirty && errorsCv.phone.error ? (
                      <p className="errors-msg">{errorsCv.phone.message}</p>
                    ) : null}
                  </div>
                </div>
              </div>
            </fieldset>
            <div className="col-12 d-flex justify-content-between buttons-div">
              <div>
                <label className="settings_button-border button-b-secondary button_mobile mb-1 d-flex justify-content-between">
                  Cargar CV <ArrowUpwardIcon />
                  <input
                    type="file"
                    hidden
                    id="filename"
                    name="filename"
                    onChange={handleFileCv}
                    onBlur={onBlurFieldCv}
                  />
                </label>
                {errorsCv.filename.dirty && errorsCv.filename.error ? (
                  <p className="errors-msg">{errorsCv.filename.message}</p>
                ) : null}
              </div>
              <button
                type="submit"
                className="settings_button-pleno bg-p-secondary button_mobile button_upload_cvform mb-4 d-flex justify-content-between"
              >
                Enviar
                <ArrowForwardIcon />
              </button>
            </div>
          </form>
        </section>
      </div>
    </>
  );
};

export default UploadCV;
